<template>
    <div>
        <!--        <div><h1>你的邀请码是:{{invite_id}}</h1></div>-->

        <!--        <van-button plain type="danger" @click="createShare">生成邀请海报</van-button>-->
        <div>
            <Wp_share_poster class="back_div"
                             :share-url="newLink"
                             :activeShow="activeShow"
                             share-tip="扫码快速加入"
                             :useTo="useTo"
                             :share-image="share_img_url"
            >
                <div style="text-align: center">
                    <Wp_image v-if="share_img_url" :url="share_img_url" width="100%"/>
                </div>
                <div slot="text" style="min-height: 80px; margin-left: 7px">
                    <div class="info_text">{{text}}</div>
                    <div v-if="wxUserInfo && wxUserInfo.headimgurl">
                        <van-row>
                            <van-col span="6" style="padding: 5px">
<!--                                <wp_img type="round" :src="wxUserInfo.headimgurl" width="90%" height="90%"></wp_img>-->
                                <img :src="wxUserInfo.headimgurl" width="90%" height="90%" style="border-radius: 50%;">
                            </van-col>
                            <van-col span="18">
                                <div class="user_div">
                                    <div class="user_name_div">好友{{wxUserInfo.nickname}}</div>
                                    <div class="user_desc_div">推荐您加入万品京选</div>
                                    <div class="user_desc2_div">京东社交电商战略合作伙伴</div>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                    <div v-else>
                        <div class="user_div">
                            <div class="user_name_div">您的好友</div>
                            <div class="user_desc_div">邀请您加入万品京选</div>
                            <div class="user_desc2_div">京东社交电商战略合作伙伴</div>
                        </div>
                    </div>
                </div>
<!--                <div v-if="useTo && useTo === 'h5'" slot="bottom" style="padding: 5px">-->
<!--                    <van-steps :active="2" active-color="#FF0000"-->
<!--                               active-icon="passed"-->
<!--                               inactive-icon="circle"-->
<!--                               style="">-->

<!--                        <van-step style="color: #FF0000">扫码关注微信公众号</van-step>-->
<!--                        <van-step style="color: #FF0000">进入公众号</van-step>-->
<!--                        <van-step style="color: #FF0000">快速注册超级会员</van-step>-->
<!--                    </van-steps>-->
<!--                </div>-->

            </Wp_share_poster>
        </div>
    </div>
</template>

<script>
    import Wp_share_poster from "./Wp_share_poster";
    import Wp_image from "./Wp_image";

    export default {
        name: "Wp_invite_by_qrcode",
        components: {Wp_image, Wp_share_poster},
        props: {
            inviteId: {type: String, default: ''},
            activeShow: {type: String, default: ''},
            wxUserInfo: {type: Object},
            useTo:{type: String, default: ''},
            newLink:{type: String, default: ''},
            shareImgUrl: {type: String, default: ''}
        },
        data() {
            return {
                // invite_id: "456",
                text: '扫码关注,快速注册来赚钱！',
                // newLink: null,
                // show_share_pop: "",
                share_img_url: "/images/share_02.png",
            }
        },

        created() {
            if(this.shareImgUrl){
                this.share_img_url = this.shareImgUrl;
            }
            this.share_img_url += "?t=" + new Date().getTime();
            // this.$log("this.share_img_url = " + this.share_img_url)
        },
        mounted() {
            // this.createShare();
        },

        watch:{
            newLink(newValue){
                // this.$log("newlink = " + newValue)
                this.newLink = newValue;
            },
            activeShow(newValue){
                // this.$log("activeShow = " + newValue)
                this.activeShow = newValue;
            },
            // shareImgUrl(newImgUrl){
            //     this.share_img_url = newImgUrl;
            //     this.$log("this.share_img_url = " + this.share_img_url)
            // }
        },

        methods: {

            createShare() {
                this.$log(this.$refs.wp_jd_help)
                if (this.isWxBrowser) {
                    this.$refs.wp_jd_help.initWxUserInfo(response => {
                        this.$log(response);

                    })
                }

            },

            isWxBrowser() {
                let userAgent = navigator.userAgent;
                this.$log("userAgent = " + userAgent);
                if (userAgent && userAgent.indexOf("MQQBrowser") !== -1) {
                    return true
                } else {
                    return false;
                }
            }

            // createShare(){
            //     let timestamp = "_" + Date.parse(new Date());
            //     this.show_share_pop = timestamp;
            // }
        }


    }
</script>

<style scoped>
    .back_div {
        background-color: lightgray;
    }

    .info_text {
        color: red;
        font-size: 15px;
    }

    .user_div {
        margin-top: 2px;
        /*margin-left: 2px;*/
    }

    .user_name_div {
        font-size: 16px;
        color: #323233;

    }

    .user_desc_div {
        font-size: 12px;
        color: #6e6e70;
    }

    .user_desc2_div {
        font-size: 12px;
        color: #6e6e70;
    }

</style>